import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
const t = key => app.translator.trans(`tarotportal-theme.forum.discussion.guest_${key}`);

/**
 * Shown to guests at the end of a discussion instead of the "Написать ответ…" field, which
 * looks editable but is not. Both actions open core's own modals; after logging in core
 * reloads the page and the regular reply placeholder appears.
 */
export default class GuestReplyCta extends Component {
  view() {
    return m("section", {
      className: "TpReplyCta",
      "aria-labelledby": "tp-reply-cta-title"
    }, m("div", {
      className: "TpReplyCta-text"
    }, m("p", {
      className: "TpEyebrow"
    }, t('eyebrow')), m("h3", {
      className: "TpReplyCta-title",
      id: "tp-reply-cta-title"
    }, t('title')), m("p", {
      className: "TpReplyCta-lead"
    }, t('text'))), m("div", {
      className: "TpReplyCta-actions"
    }, m(Button, {
      className: "Button Button--primary TpReplyCta-login",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('core.forum.header.log_in_link')), app.forum.attribute('allowSignUp') && m(Button, {
      className: "Button Button--link TpReplyCta-signup",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, app.translator.trans('core.forum.header.sign_up_link'), " \u2192")));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/GuestReplyCta', GuestReplyCta);